import { useEffect, useState } from "react";
import {  rmaColumnVisibilityItems } from "./components/columnVisibilityItems";
import { connect } from "react-redux";
import { fetchInAppPurchaseResponse } from "../store/action";
import ServerTable from "components/table/ServerTable";
import { InAppPaymentTableColumns } from "./components/InAppPaymentTableColimns";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;
const InAppPurchaseTable: React.FC<Props> = ({
  fetchPaymentResponse,
  onFetchInAppPayment,
  // onResetDcddData
}) => {
  const [limit, setLimit] = useState(20);
  const [pageIndex, setPageIndex] = useState(0); 
  const [hasNext] = useState(true);
  const rmaPaymentData = fetchPaymentResponse?.inAppPurchaseResponse;
  useEffect(() => {
    onFetchInAppPayment()
  }, [onFetchInAppPayment]);
  const handlePaginationChange = (newLimit: number, newOffset: number) => {
  const newPageIndex = Math.floor(newOffset / newLimit);
  setLimit(newLimit);
  setPageIndex(newPageIndex);
  onFetchInAppPayment();
};

  const downloadExcel = (data: any[]) => {
    if (!data || data.length === 0) return;
    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((field) => `<td>${row[field] ?? ""}</td>`)
            .join("")}</tr>`
      )
      .join("");

    const tableHTML = `
    <table>
      <thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>
      <tbody>${rows}</tbody>
    </table>`;

    const blob = new Blob(
      [
        `\uFEFF<html><head><meta charset="UTF-8"></head><body>${tableHTML}</body></html>`,
      ],
      { type: "application/vnd.ms-excel" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "dcdd_users.xls";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <ServerTable
        headers={["Report", "In App Payment Response"]}
        data={rmaPaymentData}
        columnVisibilityItems={rmaColumnVisibilityItems}
        tableColumns={InAppPaymentTableColumns}
        addButton={<div>
          <button
            className="border px-3 py-2 bg-primary-500 mx-2 rounded-md hover:bg-primary-800 text-primary-100 hover:text-white hover:shadow-md"
            onClick={() => downloadExcel(rmaPaymentData)}
          >
            Download Excel
          </button>
        </div>} 
        onPaginationChange={handlePaginationChange} 
        pageIndex={pageIndex} 
        pageSize={limit} 
        hasNext={hasNext}      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
     fetchPaymentResponse: state.paymentResponse.fetchPaymentState
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onFetchInAppPayment: () => dispatch(fetchInAppPurchaseResponse()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InAppPurchaseTable);
